module.exports = __webpack_public_path__ + "assets/Depression.334da917.png";